import React, { useEffect } from "react";
import './App.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "./components/header";
import Footer from "./components/footer";
import { Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
import Brands from "./pages/brands";
import Career from "./pages/career";
import Services from "./pages/services";
import Blog from "./pages/blog";
import Contact from "./pages/contact";
import { useTranslation } from "react-i18next";
import KFMB from "./subPages/kfmb";
import Seed from "./subPages/seed";
import EFR from "./subPages/efr";
// import Tesla from "./subPages/tesla";
// import Pandy from "./subPages/pandy";
// import LFC from "./subPages/lfc";
// import Impact from "./subPages/impact";
import Admin from './admin/Admin'
import Post from "./pages/post";
import AllPosts from "./pages/allPosts";
import Trillo from "./subPages/trillo";
import WrapMaster from "./subPages/wrapMaster";
import GoldenShine from "./subPages/goldenShine";

function App() {
  const location = useLocation()
  const { t, i18n } = useTranslation()
  useEffect(() => {
    const mainEl = document.createElement('script')
    mainEl.setAttribute('src', '/main.js')
    const swipeEl = document.createElement('script')
    swipeEl.setAttribute('src', '/swiper-bundle.min.js')
    document.head.appendChild(swipeEl)
    document.head.appendChild(mainEl)
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname])
  useEffect(() => {
    const lang = i18n.language || 'en';
    const dir = lang === 'ar' ? 'rtl' : 'ltr';

    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [i18n.language]);
  return (
    <React.Fragment>
      <Routes>
        <Route path="/admin/*" exact element={<Admin />} />
      </Routes>
      {!location.pathname.includes('admin') &&
        <React.Fragment>
          <Header />
          <main className="pt-[80px]">
            <Routes>
              <Route path="/" exact element={<Home />} />
              <Route path="/about" exact element={<About />} />
              <Route path="/brands" exact element={<Brands />} />
              <Route path="/brands/kfmb" exact element={<KFMB />} />
              <Route path="/brands/seedawi" exact element={<Seed />} />
              <Route path="/brands/egyptian-rice" exact element={<EFR />} />
              <Route path="/brands/trillo" exact element={<Trillo />} />
              <Route path="/brands/wrap-master" exact element={<WrapMaster />} />
              <Route path="/brands/golden-shine" exact element={<GoldenShine />} />
              {/* <Route path="/brands/pandy" exact element={<Pandy />} />
              <Route path="/brands/lfc" exact element={<LFC />} />
              <Route path="/brands/impact" exact element={<Impact />} /> */}
              <Route path="/career" exact element={<Career />} />
              <Route path="/services" exact element={<Services />} />
              <Route path="/blog" exact element={<Blog />} />
              <Route path="blog/:id" element={<Post />} />
              <Route path="/contact" exact element={<Contact />} />
              <Route path="/all-posts" exact element={<AllPosts />} />
            </Routes>
          </main>
          <Footer />
        </React.Fragment>}
    </React.Fragment>
  );
}

export default App;
